<template>
  <DefaultPage id="about">
    <div class="hero hero--edges hero--edges--about">
      <div class="hero__call">
        <h1 class="about-headline-top">We're a physician owned company</h1>
        <h2 class="about-headline-mid">Always Ready</h2>
        <h1 class="about-headline-btm">To protect our members</h1>
      </div>
      <img src="../assets/bg-poly.png" class="hero-shape" alt="shape"/>
      <video class="hero__vid" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
        <source :src="`${baseUrl}gradient-vid.mp4`" type="video/mp4">
      </video>
    </div>
    <div class="sub-hero">
      <div class="sub-hero__call">
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="small-10 medium-8">
              <p>In 1976 SVMIC was created by doctors for doctors and is 100% owned and governed by our members. We provide medical malpractice insurance at an excellent value, returning an annual share of profits to members. Physician involvement and physician governance mean that we are able to always keep your interests at heart.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="our-mission"
         data-aos="fade-in"
         data-aos-duration="400">
      <div class="section-content">
        <div class="grid-container">
          <div class="grid-x align-center">
            <div class="cell xlarge-6 large-8 medium-10">
              <h3 class="our-section-headline">Our <span>Mission</span></h3>
              <div class="our-hr"></div>
              <p>Protect, support, and advocate for physicians and other healthcare providers.</p>
            </div>
          </div>
        </div>
      </div>
      <div id="logo-outline">
        <img src="../assets/logo-outline.png" alt="">
      </div>
    </div>
    <div id="our-values"
         class="our-section"
         data-aos="fade-in"
         data-aos-duration="400">
      <div class="grid-container">
        <div class="grid-x grid-padding-x align-center">
        <div class="cell medium-10 large-8">
          <h3 class="our-section-headline">Our <span>Values</span></h3>
          <div class="our-hr"></div>
        </div>
        <ValuesMasterDetail/>
      </div>
      </div>
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ValuesMasterDetail from '@/components/master-detail/ValuesMasterDetail';

export default {
  name: 'About',
  components: {
    ValuesMasterDetail,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
